export const DashboardIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect y="10" width="4" height="10" fill="currentColor" />
            <rect x="8" width="4" height="20" fill="currentColor" />
            <rect x="16" y="5" width="4" height="15" fill="currentColor" />
        </svg>
    );
};
